module.exports = __webpack_public_path__ + "07fbd430f8018680904aab33c7ed35f6.png";